import { Text } from '@smuchile/pkg-unimarc-components'

import { currencyFormat } from '@smuchile/pkg-unimarc-components/helpers'
import { useMobile } from '@smuchile/pkg-unimarc-hooks'

export interface PriceProps {
  price?: string
  totalPrice: number
}

export const Price = ({
  totalPrice
}: PriceProps): React.ReactElement<PriceProps> => {
  const { isMobile } = useMobile()
  const fontSizePrice = isMobile ? 'md' : 'lg'
  return (
    <>
      <Text
        fontSize={fontSizePrice}
        fontWeight='medium'
      >
        {currencyFormat({ number: totalPrice })}
      </Text>
    </>
  )
}
